export var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};


//////////////////
// WEBPACK FOOTER
// ../~/react-toastify/~/react-transition-group/esm/utils/reflow.js
// module id = 461
// module chunks = 0